module.exports = __webpack_public_path__ + "static/media/kcps.33870d5b.png";